jQuery(document).ready(function($) {
console.log('menu-dropdown.js loaded');
    var $menu = $('#primary-menu #item-list');

    if (!$menu.length) {
        return;
    }

    function closeAllDropdowns() {
        $menu.find('.dropdown-trigger.is-open')
            .removeClass('is-open')
            .children('a')
            .attr('aria-expanded', 'false');
    }

    $menu.find('.dropdown-trigger > a').on('click', function(event) {
        console.log('dropdown trigger clicked');
        var $trigger = $(this).parent('.dropdown-trigger');

        if (!$trigger.length) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        var isOpen = $trigger.hasClass('is-open');

        closeAllDropdowns();

        if (!isOpen) {
            $trigger.addClass('is-open');
            $(this).attr('aria-expanded', 'true');
        }
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest('#primary-menu #item-list').length) {
            closeAllDropdowns();
        }
    });

    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            closeAllDropdowns();
        }
    });
});
